import { Component, Input, Output, ViewChild, ElementRef, EventEmitter } from '@angular/core';
import { UiSettings, ZHelpers } from './../../common';
import { LocalDataSource } from 'ng2-smart-table';
import { SupplierOrderService } from './../services/supplier-order.service';
import { SupplierOrderListModel } from './../models/supplier-order-list.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OrderDetailsViewComponent } from './../details-view/order-details-view.component';


@Component({
    selector: 'z-order-details-list',
    templateUrl: `./order-details-list.template.html`,
})
export class OrderDetailsListComponent {

    constructor(protected supplierOrderService: SupplierOrderService, private modalService: NgbModal) { }

    private detailsSource = new LocalDataSource();
    private selectedItem: SupplierOrderListModel;

    @Input()
    set order(order: SupplierOrderListModel) {
        this.selectedItem = order;
        this.loadData();
    }
    @Output() close: EventEmitter<any> = new EventEmitter();

    public detailsSettings = {
        ...UiSettings.defaultSmartTableSettings, columns: {
            partNo: { title: 'Part no' },
            description: { title: 'Description' },
            plannedDate: { title: 'Planned date', valuePrepareFunction: ZHelpers.SmartTable.dateFormatter },
            qty: {
                title: 'Amount', valuePrepareFunction: (cell, row) =>
                    (cell === 1 && row.units === 'pcs' ? '1 pc' : cell + ' ' + row.units)
            },
            printed: { title: 'Printed' },
        },
        edit: {
            editButtonContent: '<div class="btn btn-xs btn-primary btn-rectangle">Print</div>',
        },
        rowClassFunction: (row) => {
            if (row.data.printed === 'Yes') {
                return 'success';
            } else if (row.data.printed === 'No') {
                return '';
            }
            return 'warning';
        },
    }

    loadData() {
        this.detailsSource.load([]);
        this.supplierOrderService.getOrder(this.selectedItem.orderNo).subscribe((data) => {
            ZHelpers.SmartTable.setData(this.detailsSource, data.lines);
        });
    }

    onItemClick(e) {
        if (!e || !e.data) {
            return;
        }
        const modalRef = this.modalService.open(OrderDetailsViewComponent, { size: 'lg' });
        modalRef.componentInstance.orderLine = e.data;
    }

    onCloseClick() {
        this.selectedItem = null;
        this.close.emit(null);
    }

}



// WEBPACK FOOTER //
// ./src/app/suppliers-barcodes/details-list/order-details-list.component.ts